import { useQueryCacheTagHelpers } from '../../tags/utils/useQueryCacheTagHelpers.js';
import { useWoody } from '../../woody/woody.js';
import { useQueryCacheResourceHelpers } from '../utils/useQueryCacheResourceHelpers.js';
import { useQueryClient, useMutation } from '@tanstack/react-query';
import { tagsQueryPredicates } from '../../tags/queries/tagsQueryPredicates.js';
import { resourceQueryPredicates } from '../queries/resourceQueryPredicates.js';
import { useUpdateCachedSmartCollection } from '../../smart-collections/mutations/smartCollectionMutationHelpers.js';
import { smartCollectionPredicates } from '../../smart-collections/queries/smartCollection.predicates.js';

const useMutationUpdateResourceListViewPreferences = () => {
  const { client } = useWoody();
  const { updateCachedResource } = useQueryCacheResourceHelpers();
  const { updateCachedTag } = useQueryCacheTagHelpers();
  const updateCachedSmartCollection = useUpdateCachedSmartCollection();
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async ({ type, id, data }) => {
      return client.v2({
        endpoint: "/v2/item-preferences/{itemType}/{itemId}",
        params: {
          itemType: type,
          itemId: id
        }
      }, {
        method: "patch",
        body: data
      });
    },
    onMutate: ({ type, id, data }) => {
      if (type === "resources") {
        return {
          optimisticUpdate: updateCachedResource({
            id,
            preferences: data
          })
        };
      }
      if (type === "tags") {
        return {
          optimisticUpdate: updateCachedTag({
            id,
            preferences: data
          })
        };
      }
      if (type === "smart-collections") {
        return {
          optimisticUpdate: updateCachedSmartCollection({
            id,
            preferences: data
          })
        };
      }
    },
    onSettled: (d, e, { type, id }) => {
      if (type === "resources") {
        queryClient.invalidateQueries({
          predicate: (q) => resourceQueryPredicates.resourceDetail(q, id)
        });
      }
      if (type === "tags") {
        queryClient.invalidateQueries({
          predicate: (q) => tagsQueryPredicates.tag(q, id)
        });
      }
      if (type === "smart-collections") {
        queryClient.invalidateQueries({
          predicate: (q) => smartCollectionPredicates.item(q, id)
        });
      }
    }
  });
};

export { useMutationUpdateResourceListViewPreferences };
//# sourceMappingURL=useMutationUpdateResourceListViewPreferences.js.map
